var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Chat_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBF5FF",
    d: "M17.095 28V5.265a4.084 4.084 0 0 1 1.207-2.9 4.119 4.119 0 0 1 2.915-1.2H64.71c1.092 0 2.139.433 2.91 1.202a4.09 4.09 0 0 1 1.207 2.898v36.888l-8.232-8.197h-8.232"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M17.095 27.5V5.265a4.084 4.084 0 0 1 1.207-2.9 4.119 4.119 0 0 1 2.915-1.2H64.71c1.092 0 2.139.433 2.91 1.202a4.09 4.09 0 0 1 1.207 2.898v36.888l-8.232-8.197h-8.232"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M49.677 17.6a2.042 2.042 0 0 1 1.27-1.893 2.066 2.066 0 0 1 2.242.444 2.046 2.046 0 0 1-1.455 3.498 2.062 2.062 0 0 1-1.455-.6 2.044 2.044 0 0 1-.603-1.449M41.45 17.6a2.042 2.042 0 0 1 1.27-1.893 2.066 2.066 0 0 1 2.242.444 2.046 2.046 0 0 1-1.455 3.498 2.062 2.062 0 0 1-1.455-.6 2.044 2.044 0 0 1-.603-1.449M33.21 17.6a2.042 2.042 0 0 1 1.271-1.893 2.066 2.066 0 0 1 2.242.444 2.046 2.046 0 0 1 .447 2.233 2.05 2.05 0 0 1-1.901 1.265 2.065 2.065 0 0 1-1.455-.6 2.048 2.048 0 0 1-.603-1.449"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Chat_svg__b)",
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M52.9 56.538V31.946a4.09 4.09 0 0 0-1.204-2.897 4.126 4.126 0 0 0-2.91-1.202H5.289a4.126 4.126 0 0 0-2.911 1.2 4.09 4.09 0 0 0-1.206 2.9v36.887l8.232-8.203h39.384c1.09 0 2.135-.432 2.907-1.2a4.09 4.09 0 0 0 1.206-2.893"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#022356",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.5,
    d: "M20.862 44.242a2.043 2.043 0 0 0-1.27-1.893 2.066 2.066 0 0 0-2.242.444 2.046 2.046 0 0 0 1.454 3.498 2.065 2.065 0 0 0 1.902-1.265c.103-.248.156-.515.156-.784M29.096 44.242a2.043 2.043 0 0 0-1.27-1.893 2.066 2.066 0 0 0-2.243.444 2.047 2.047 0 0 0-.446 2.233 2.05 2.05 0 0 0 1.901 1.265 2.064 2.064 0 0 0 1.901-1.265c.104-.248.157-.515.157-.784M37.328 44.242a2.043 2.043 0 0 0-1.27-1.893 2.066 2.066 0 0 0-2.243.444 2.046 2.046 0 0 0-.446 2.233 2.05 2.05 0 0 0 1.901 1.265 2.065 2.065 0 0 0 1.455-.6 2.047 2.047 0 0 0 .603-1.449"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Chat_svg__b",
    x1: 4.068,
    x2: 50.51,
    y1: 30.347,
    y2: 56.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.131,
    stopColor: "#FEB100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2561"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Chat_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h70v70H0z"
  })))));
};
export default SvgChat;